<template>
  <div>
    <v-navigation-drawer
      :value="isAddNewPerfilSidebarActive"
      temporary
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
      app
      @input="val => $emit('update:is-add-new-perfil-sidebar-active', val)"
    >
      <v-card height="100%">
        <div class="drawer-header d-flex align-center mb-4">
          <span class="font-weight-semibold text-base text--primary">Adicionar perfil</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="$emit('update:is-add-new-perfil-sidebar-active', false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="onSubmit"
          >
            <v-text-field
              v-model="perfilData.nome"
              outlined
              dense
              :rules="[validators.required, (v) => (!!v && v.length <= 100) || 'Máximo de 100 caracteres']"
              label="Nome"
              placeholder="Nome"
              hide-details="auto"
              class="mb-6"
            ></v-text-field>

            <v-textarea
              v-model="perfilData.descricao"
              outlined
              auto-grow
              dense
              label="Descrição"
              placeholder="Descrição"
              hide-details="auto"
              class="mb-6"
            ></v-textarea>

            <v-btn
              color="primary"
              class="me-3 mb-1"
              type="submit"
            >
              <v-progress-circular
                v-if="loadings"
                class="mx-6"
                indeterminate
                color="secundary"
              ></v-progress-circular>
              <span v-else> Adicionar </span>
            </v-btn>
            <v-btn
              color="secondary"
              class="mb-1"
              outlined
              type="reset"
              @click="resetPerfilData"
            >
              Cancelar
            </v-btn>
          </v-form>

          <v-alert
            v-if="msgsSuccess"
            class="mt-4"
            dense
            dismissible
            type="success"
          >
            Cadastrado com sucesso!
          </v-alert>
          <v-alert
            v-if="msgsError"
            class="mt-4"
            shaped
            outlined
            type="error"
          >
            {{ errorMsg }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  nameValidator,
  emailValidator,
  passwordValidator,
  required,
  select,
} from '@core/utils/validation'
import { mdiClose, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { isTelefoneCelularValido, isCpfValido } from '@/utils/validation'
import PerfilService from '@/services/modules/PerfilService'

export default {
  model: {
    prop: 'isAddNewPerfilSidebarActive',
    event: 'update:is-add-new-perfil-sidebar-active',
  },
  props: {
    isAddNewPerfilSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const blankperfilData = {
      nome: '',
      descricao: '',
    }

    const valid = ref(false)
    const form = ref(null)

    const msgsSuccess = ref(false)
    const msgsError = ref(false)
    const loadings = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const perfilData = ref(JSON.parse(JSON.stringify(blankperfilData)))
    const errorMsg = ref('Entre em contato com o servidor.')

    const resetPerfilData = () => {
      msgsError.value = false
      perfilData.value = JSON.parse(JSON.stringify(blankperfilData))
      resetForm()
      setTimeout(() => {
        emit('update:is-add-new-perfil-sidebar-active', false)
      }, 1000)
    }

    const onSubmit = () => {
      loadings.value = !loadings.value

      if (valid.value) {
        PerfilService.criar(perfilData.value)
          .then(() => {
            loadings.value = !loadings.value
            msgsSuccess.value = !msgsSuccess.value
            setTimeout(() => {
              msgsSuccess.value = !msgsSuccess.value
            }, 6000)
            emit('refetch-data')
            resetPerfilData()
          })
          .catch(() => {
            msgsError.value = !msgsError.value
            setTimeout(() => {
              msgsError.value = !msgsError.value
            }, 6000)
            loadings.value = !loadings.value
          })
      } else {
        loadings.value = !loadings.value
        validate()
      }
    }

    return {
      resetPerfilData,
      onSubmit,
      validate,
      form,
      perfilData,
      valid,
      msgsSuccess,
      msgsError,
      blankperfilData,
      loadings,
      errorMsg,

      // validation
      validators: {
        required,
        emailValidator,
        select,
        nameValidator,
        isCpfValido,
        passwordValidator,
        isTelefoneCelularValido,
      },
      icons: {
        mdiClose,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>
